import {
  createPolygonPath,
  getViewBox,
  toViewBoxString
} from '@refra/modules/refra-static-parts/components/StaticPartReplacementEdit/Detail/DetailDrawing/helpers'
import {StaticPartsColors} from '@refra/modules/refra-static-parts/enums'
import {StaticPartComponentDto} from '@refra/modules/refra-static-parts/types'

interface StaticPartDrawingProps {
  selectedComponent: StaticPartComponentDto
  selectedAreas?: {id: number}[][]
}

export const StaticPartDetailDrawing = ({
  selectedComponent,
  selectedAreas
}: StaticPartDrawingProps) => {
  const viewBox = toViewBoxString(getViewBox(selectedComponent))
  const selectedIds = selectedAreas?.map(
    (area) => new Set(area?.map((section) => section.id.toString()) ?? [])
  )

  const getFillColor = (sectionId: string) => {
    const index = selectedIds?.findIndex((ids) => ids.has(sectionId)) ?? -1
    return index > -1 ? StaticPartsColors[index % StaticPartsColors.length] : 'none'
  }

  return (
    <svg viewBox={viewBox} className="w-full h-full" preserveAspectRatio="xMidYMid meet">
      <g id="annotationShapes">
        {selectedComponent.annotationShapes?.map((annotationShape, index) => (
          <polygon
            key={`${selectedComponent.id}-annotationShape-${index}`}
            id={`annotationShape-${index}`}
            points={createPolygonPath(annotationShape.vertices)}
            className="
            stroke-black
            stroke-[0.03]
            cursor-pointer
            fill-transparent
          "
          />
        ))}
      </g>
      <g id="annotationLabels">
        {selectedComponent.annotationLabels?.map((annotationLabel, index) => (
          <text
            key={`${selectedComponent.id}-annotationLabel-${index}`}
            x={annotationLabel.position.x}
            y={-annotationLabel.position.y}
            transform={`rotate(${annotationLabel.rotation}, ${annotationLabel.position.x}, ${-annotationLabel.position.y})`}
            fontSize={annotationLabel.height}
            className="fill-black cursor-pointer"
            textAnchor="middle"
            dominantBaseline="middle"
          >
            {annotationLabel.text}
          </text>
        ))}
      </g>
      <g id="sections">
        {selectedComponent.sections.map((section) => (
          <polygon
            key={`${selectedComponent.id}-polygon-${section.id}`}
            id={`polygon-${section.id}`}
            points={createPolygonPath(section.vertices)}
            className="
            fill-transparent
            stroke-black
            stroke-[0.03]
            cursor-pointer
            transition-all
            duration-200
          "
            style={{
              fill: getFillColor(section.id.toString())
            }}
          />
        ))}
      </g>
    </svg>
  )
}
